import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 40% !important;
  background-color: transparent;
  color: ${props => props.theme.colors.c03};
  display:flex;
  justify-content: center;
  align-items: center;
  position: relative;
  top: 0;
  padding: 10px;
  margin: 0 0 0 0;
`;

export const BackLogin = styled.div`
  width: 100%;
  height: 100% !important;
  background-color:  transparent;
  display:flex;
  justify-content: flex-start;
  align-items: top;
  padding:0 ;
  top:150px;
  margin: 0;
  border-radius: 5px;
  position: relative;
`;

export const RowLogin = styled.div `
  display: flex;
  align-items: center;
  position:relative;
  width: 100%;
`;